import { Button } from '../../atoms/Button';

/**
 * Terminal sign-in error with a retry affordance. Pure — the consumer wires the
 * retry action (e.g. restart login). Was `advisor-platform`'s `AuthErrorRetry`.
 */
export function AuthErrorState({ onRetry }: { onRetry: () => void }) {
  return (
    <main className="mx-auto flex max-w-sm flex-col items-center gap-4 p-6 text-center">
      <p role="alert" className="text-text-primary">
        We couldn&apos;t complete sign-in. Please try again.
      </p>
      <Button onClick={onRetry}>Try again</Button>
    </main>
  );
}
